<div class="pdv-container h-100 d-flex flex-column">
  <!-- Cabeçalho Simplificado -->
  <div class="pdv-header bg-white border-bottom p-2 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <button class="btn btn-light btn-rounded mr-2" (click)="voltar()">
        <i class="fa fa-arrow-left"></i>
      </button>
      <h5 class="m-0"><i class="fe-shopping-cart text-primary"></i> {{tituloPagina}}</h5>
    </div>
    <div>
      <span class="badge badge-success font-14 p-2" *ngIf="pedido.total > 0">
        Total: {{ pedido.total | currency:'BRL' }}
      </span>
    </div>
  </div>

  <div class="row no-gutters flex-grow-1 overflow-hidden">

    <!-- COLUNA ESQUERDA: CATÁLOGO DE PRODUTOS -->
    <div class="col-md-7 col-lg-8 h-100 border-right bg-light d-flex flex-column">
      <div class="p-0 flex-grow-1 overflow-auto h-100">
        <!-- Reutiliza o componente de adicionar produto, mas forçando ele a ficar visível -->
        <app-tela-adicionar-produto-pdv #telaAdicionarProduto
          (onAdicionou)="adicioneProduto($event)"
          (onAtualizou)="atualizeProduto($event)"
          (onCancelouAdicionar)="canceleAdicionar($event)">
        </app-tela-adicionar-produto-pdv>
      </div>
    </div>

    <!-- COLUNA DIREITA: DADOS DO PEDIDO -->
    <div class="col-md-5 col-lg-4 h-100 bg-white d-flex flex-column shadow-sm">
      <form #frm="ngForm" class="h-100 d-flex flex-column">
      <!-- ABAS: CARRINHO vs PAGAMENTO -->
      <div class="pdv-tabs d-flex border-bottom">
        <button class="btn flex-fill rounded-0"
          [class.btn-primary]="abaAtual === 'carrinho'"
          [class.btn-light]="abaAtual !== 'carrinho'"
          (click)="voltarParaCarrinho()">
          <i class="fe-list"></i> Pedido
        </button>
        <button class="btn flex-fill rounded-0"
          [class.btn-primary]="abaAtual === 'pagamento'"
          [class.btn-light]="abaAtual !== 'pagamento'"
          (click)="irParaPagamento()"
          [disabled]="pedido.itens.length === 0">
          <i class="fe-dollar-sign"></i> Pagamento
        </button>
      </div>

      <!-- CONTEÚDO: CARRINHO -->
      <div class="d-flex flex-column flex-grow-1 overflow-hidden" *ngIf="abaAtual === 'carrinho'">

        <!-- Cliente e Tipo -->
        <div class="p-3 bg-light border-bottom">
          <div class="btn-group w-100 mb-2">
            <button class="btn btn-sm" [class.btn-dark]="pedido.balcao" [class.btn-outline-secondary]="!pedido.balcao" (click)="mudarTipoEntrega('BALCAO')">Balcão / Retirar</button>
            <button class="btn btn-sm" [class.btn-dark]="!pedido.balcao" [class.btn-outline-secondary]="pedido.balcao" (click)="mudarTipoEntrega('ENTREGA')">Entrega</button>
          </div>

          <app-buscar-contato #buscarContato [borda]="true"
            (onBuscouContato)="contatoFoiBuscado($event)"
            [mensagem]="'Buscar Cliente (F2)'">
          </app-buscar-contato>

          <!-- Se for Entrega, mostra endereços -->
          <div *ngIf="!pedido.balcao" class="mt-2">

            <div *ngIf="!contato.id" class="alert alert-info p-2 font-12">
              <i class="fa fa-user"></i> Identifique o cliente acima para configurar a entrega.
            </div>

            <ng-container *ngIf="contato.id">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <small class="text-muted">Endereço de Entrega:</small>
                <button class="btn btn-sm btn-link p-0" (click)="novoEndereco()">+ Novo</button>
              </div>

              <div class="input-group mb-2" *ngIf="enderecos.length > 0">
                <kendo-dropdownlist
                  [data]="enderecos"
                  [textField]="'descricaoCompleta'"
                  [valueField]="'id'"
                  [(ngModel)]="pedido.entrega.endereco"
                  (valueChange)="selecionarEndereco($event)"
                  class="form-control"
                  style="height: auto;">
                </kendo-dropdownlist>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="editarEndereco()" [disabled]="!pedido.entrega.endereco">
                    <i class="fa fa-edit"></i>
                  </button>
                </div>
              </div>

              <div *ngIf="enderecos.length === 0" class="alert alert-warning p-2 font-12">
                Cliente sem endereço cadastrado.
                <button class="btn btn-sm btn-primary ml-2" (click)="novoEndereco()">Cadastrar</button>
              </div>

              <!-- Taxa de Entrega Manual/Calculada -->
              <div class="form-group mb-0" *ngIf="pedido.entrega.endereco">
                 <label class="font-12 text-muted mb-0">Taxa de Entrega</label>
                 <div class="d-flex align-items-center">
                   <kendo-numerictextbox
                     [(ngModel)]="pedido.entrega.taxaDeEntrega"
                     (valueChange)="pedido.calculeTotal()"
                     [format]="'c2'"
                     [min]="0"
                     [spinners]="false"
                     class="form-control form-control-sm mr-2">
                   </kendo-numerictextbox>
                   <span *ngIf="calculandoTaxa" class="text-info font-12"><i class="fa fa-spin fa-spinner"></i></span>
                 </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Grid de Itens -->
        <div class="flex-grow-1 overflow-auto p-0">
          <app-grid-produtos #listaDePedidos [tela]="this" (onEditar)="editeItemPedido($event)"></app-grid-produtos>
        </div>

        <!-- Totais -->
        <div class="p-3 bg-light border-top">
          <div class="d-flex justify-content-between mb-1">
            <span>Subtotal:</span>
            <span>{{ pedido.subTotal | currency:'BRL' }}</span>
          </div>
          <div class="d-flex justify-content-between mb-1" *ngIf="pedido.entrega.taxaDeEntrega">
            <span>Taxa Entrega:</span>
            <span>{{ pedido.entrega.taxaDeEntrega | currency:'BRL' }}</span>
          </div>
          <div class="d-flex justify-content-between h4 mt-2 font-weight-bold">
            <span>Total:</span>
            <span class="text-success">{{ pedido.total | currency:'BRL' }}</span>
          </div>
          <button class="btn btn-success btn-block btn-lg mt-2" (click)="irParaPagamento()">
            Pagamento (F9)
          </button>
        </div>
      </div>

      <!-- CONTEÚDO: PAGAMENTO -->
      <div class="d-flex flex-column flex-grow-1 overflow-hidden" *ngIf="abaAtual === 'pagamento'">
        <div class="p-3 flex-grow-1 overflow-auto">

          <!-- Cashback -->
          <div *ngIf="pedido.cashback && obtenhaSaldoCartao() > 0" class="mb-3">
            <h6 class="alert alert-success d-block p-2 font-14">
              <i class="fa fa-check mr-1"></i> Saldo de Cashback: <b>{{ obtenhaSaldoCartao() | currency:"BRL"}}</b>
            </h6>

            <div class="form-group mb-0">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="usarCashback"
                       [checked]="usarSaldo" (change)="toggleUsarCashback(usarSaldo)">
                <label class="custom-control-label" for="usarCashback">
                  Usar saldo para abater do valor total
                </label>
              </div>
            </div>

            <div *ngIf="usarSaldo" class="mt-2 pl-4 text-muted font-13">
               Valor utilizado: <b>{{ pedido.cashback.valor | currency:'BRL' }}</b>
            </div>
          </div>

          <!-- Cupons e Descontos -->
          <div class="row mb-3">
            <div class="col-12 col-lg-6">
              <label>Desconto (R$)</label>
              <kendo-numerictextbox [(ngModel)]="pedido.desconto" format="c2" [min]="0"
                                    (ngModelChange)="recalculeTotal()" class="form-control"
                                    [disabled]="pedido.obtenhaDescontosProdutos() > 0">
              </kendo-numerictextbox>
            </div>
            <div class="col-12 col-lg-6" [hidden]="pedido.obtenhaDescontosProdutos()">
              <label>Cupom Promocional</label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Código" [(ngModel)]="pedido.codigoCupom"
                       [disabled]="aplicandoCupom || (pedido.cupom && pedido.cupom.brindeResgate)">
                <div class="input-group-append">
                  <button class="btn btn-outline-primary" type="button" (click)="apliqueCupom()">Aplicar</button>
                </div>
              </div>
              <div *ngIf="erroCupom" class="text-danger font-12 mt-1">{{erroCupom}}</div>
            </div>
          </div>

          <h5 class="text-center mb-4 border-top pt-3">Total a Pagar: <span class="text-success">{{ pedido.obtenhaValorAhPagar() | currency:'BRL' }}</span></h5>

          <app-grid-pagamento #gridPagamentos
            [frm]="frm"
            (mudouFormaPagamento)="mudouFormaPagamento()"
            (alterouOpcaoMultiplasFormas)="alterouOpcaoMultiplasFormas()"
            (calculeTroco)="calculeTroco()"
            [totalPagar]="pedido.obtenhaValorAhPagar()"
            [totalProdutos]="pedido.obtenhaValorAhPagarProdutos()"
            [modoPdv]="true"
            [formasDePagamento]="formasDePagamento">
          </app-grid-pagamento>

          <div class="alert alert-danger mt-3" *ngIf="msgErro">
            {{ msgErro }}
          </div>
        </div>

        <div class="p-3 border-top">
          <button class="btn btn-success btn-block btn-lg" (click)="finalizarPedido()">
            <i class="fa fa-check"></i> FINALIZAR PEDIDO
          </button>
        </div>
      </div>

      </form>
    </div>
  </div>
</div>
